<div class="modal-body wrapper-modal main-container px-0 px-md-4 pt-4">
  <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
  <div class="title pt-3 pt-sm-0">Inspección preoperacional de vehículos</div>
  <div class="py-1 px-2 col-12 alert mb-4 text-bold text-center" *ngIf="data?.inspect?.id" [ngClass]="{'warning-text': !utils.isDefined(data?.inspect?.approval),
              'success-text': data?.inspect?.approval,
              'danger-text': utils.isDefined(data?.inspect?.approval) && !data?.inspect?.approval
    }">
    <i class="fas"
      [ngClass]="{'fa-check-circle': data?.inspect?.approval, 'fa-exclamation-circle': !data?.inspect?.approval}"></i>
    {{utils.isDefined(data?.inspect?.approval)? data?.inspect?.approval ? 'Aprobado' : 'Rechazado' : 'Sin aprobar'}}
  </div>
  <form>
    <mat-card-content class="d-flex flex-wrap my-3">
      <div class="pl-0 col-md-6" *ngIf="approvalUserInformation">
        <label class="label-field">{{utils.isDefined(data?.inspect?.approval) && data?.inspect?.approval ? 'Aprobado' :
          'Rechazado'}} por:</label>
        <input type="text" class="form-control" value="{{approvalUserInformation}}" readonly>
      </div>
      <div class="pl-0 col-12" [ngClass]="{'col-md-6': approvalUserInformation}" *ngIf="createdUserInformation">
        <label class="label-field">
          {{typeOfInspection === 'form' ? 'Creado por:' : 'Subido por:'}}
        </label>
        <input type="text" class="form-control" value="{{createdUserInformation}}" readonly>
      </div>
    </mat-card-content>
  </form>
  <div *ngIf="canApproveInspection">
    <mat-form-field appearance="standard">
      <mat-label>Responsable de la aprobación/rechazo</mat-label>
      <input type="text" matInput [formControl]="approvalUserControl">
      <i *ngIf="!changeApprovalUser && typeOfInspection === 'document'" matSuffix matTooltip="Editar"
        matTooltipPosition="above" class="fas fa-pencil-alt cursor-pointer color-primary"
        (click)="setNewApprovalUser(true)"></i>
      <i *ngIf="changeApprovalUser" matSuffix matTooltip="Cancelar" matTooltipPosition="above"
        class="fas fa-times cursor-pointer cancel" (click)="setNewApprovalUser(false)"></i>
    </mat-form-field>
    <app-input-document-user *ngIf="changeApprovalUser" [inputFormControl]="changeApprovalUserControl"
      [options]="optionsDocumentUser">
    </app-input-document-user>
  </div>

  <div class="container-checklist" *ngIf="getQuestionFlag">
    <mat-expansion-panel [expanded]="true" class="dialog-inspection-section my-3" *ngIf="showFatigueTest">
      <mat-expansion-panel-header>
        <mat-panel-title class="text-strong">
          Test de fatiga del conductor
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="d-flex flex-wrap flex-column">
        <mat-form-field appearance="standard" class="col-12 p-0">
          <mat-label>¿Cuántas horas lleva despierto?<span class="asterisk">*</span></mat-label>
          <mat-select placeholder="Seleccione una opción" [formControl]="fatigueTestForm.get('hoursAwake')">
            <mat-option *ngFor="let option of hoursAwakeOptions" [value]="option">
              {{option}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="fatigueTestForm.get('hoursAwake').errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="standard" class="col-12 p-0">
          <mat-label>¿Cuántas horas corridas ha dormido en las últimas 24 horas?<span
              class="asterisk">*</span></mat-label>
          <mat-select placeholder="Seleccione una opción" [formControl]="fatigueTestForm.get('hoursOfSleep')">
            <mat-option *ngFor="let option of hoursAwakeOptions" [value]="option">
              {{option}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="fatigueTestForm.get('hoursOfSleep').errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="standard" class="col-12 p-0">
          <mat-label>¿Está tomando medicamentos que producen sueño?<span class="asterisk">*</span></mat-label>
          <mat-select placeholder="Seleccione una opción" [formControl]="fatigueTestForm.get('takingSleepMedications')">
            <mat-option [value]="true">
              Si
            </mat-option>
            <mat-option [value]="false">
              No
            </mat-option>
          </mat-select>
          <mat-error *ngIf="fatigueTestForm.get('takingSleepMedications').errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="standard" class="col-12 p-0">
          <mat-label>¿Se encuentra en optimas condiciones de salud para {{inspection === 'cargoVehicle' ? 'operar un
            vehículo de carga' : 'conducir el vehículo' }}?<span class="asterisk">*</span></mat-label>
          <mat-select placeholder="Seleccione una opción" [formControl]="fatigueTestForm.get('optimalHealthToDrive')">
            <mat-option [value]="true">
              Si
            </mat-option>
            <mat-option [value]="false">
              No
            </mat-option>
          </mat-select>
          <mat-error *ngIf="fatigueTestForm.get('optimalHealthToDrive').errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
          </mat-error>
        </mat-form-field>

      </div>
    </mat-expansion-panel>
    <ng-container *ngIf="typeOfInspection === 'form'">
      <mat-expansion-panel [expanded]="true" *ngFor="let section of inspectionQuestions | keyvalue: originalOrder"
        class="dialog-inspection-section my-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="text-strong">
            {{sections[section.key]}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-card-content class="d-flex flex-wrap align-items-end">
          <p *ngIf="isVehicleInspectionv3 && section.key === 'elementos de proteccion personal'" class="col-12">
            ¿El vehículo cuenta con los siguientes elementos?
          </p>
          <div class="d-flex flex-wrap col-12 p-0 px-md-2"
            [ngClass]="{'col-md-6':!showQuestionObservation(visualQuestion)}"
            *ngFor="let visualQuestion of section.value">

            <label class="label-field font p-0 col-12" *ngIf="showQuestionLabel(visualQuestion)">
              {{visualQuestion.name}}
              <i class="fas fa-question-circle fa-lg cursor-pointer" *ngIf="visualQuestion.description"
                [matTooltip]="visualQuestion.description"></i>
            </label>

            <div *ngIf="showQuestionAvailable(visualQuestion)"
              class="col-12 p-0 d-flex flex-wrap justify-content-between align-items-center"
              [ngClass]="{'col-md-6':showQuestionObservation(visualQuestion), 'mb-2':!showQuestionStatus(visualQuestion)}">
              <p class="m-0 p-0">
                {{isVehicleInspectionv3 ? visualQuestion.name : 'Presente:'}}
                <i class="fas fa-question-circle fa-lg cursor-pointer"
                  *ngIf="visualQuestion.description && isVehicleInspectionv3"
                  [matTooltip]="visualQuestion.description"></i>
              </p>
              <mat-button-toggle-group
                [(ngModel)]="getArrayByName(visualQuestion.inspectionAttribute)[getQuestionIndex(visualQuestion.code, visualQuestion.inspectionAttribute)].available">
                <mat-button-toggle [value]="true" [disabled]="data.disabled">
                  Si
                </mat-button-toggle>
                <mat-button-toggle [value]="false" [disabled]="data.disabled">
                  No
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>

            <mat-form-field appearance="standard" *ngIf="showQuestionStatus(visualQuestion)" class="col-12 p-0"
              [ngClass]="{'col-md-6':showQuestionObservation(visualQuestion)}">
              <mat-select
                [(ngModel)]="getArrayByName(visualQuestion.inspectionAttribute)[getQuestionIndex(visualQuestion.code, visualQuestion.inspectionAttribute)].status"
                [ngModelOptions]="{standalone: true}" placeholder="Seleccione una opción" [disabled]="data.disabled">
                <mat-option *ngFor="let option of getRealOptions" [value]="option" [disabled]="data.disabled">
                  {{isVehicleInspectionv3 && useQuestionAlias ? getAliasOption(motorcycleOptions[option]):
                  getAliasOption(option)}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="standard" *ngIf="showQuestionResponse(visualQuestion)" class="col-12 p-0"
              [ngClass]="{'col-md-6':showQuestionObservation(visualQuestion)}">
              <mat-select
                [(ngModel)]="getArrayByName(visualQuestion.inspectionAttribute)[getQuestionIndex(visualQuestion.code, visualQuestion.inspectionAttribute)].response"
                [ngModelOptions]="{standalone: true}" placeholder="Seleccione una opción" [disabled]="data.disabled">
                <mat-option *ngFor="let option of getRealOptions" [value]="option" [disabled]="data.disabled">
                  {{isVehicleInspectionv3 && useQuestionAlias ? getAliasOption(motorcycleOptions[option]):
                  getAliasOption(option)}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div class="col-12 p-0" *ngIf="showQuestionObservation(visualQuestion)">
              Observaciones:
              <mat-form-field>
                <input matInput [disabled]="data.disabled"
                  [(ngModel)]="getArrayByName(visualQuestion.inspectionAttribute)[getQuestionIndex(visualQuestion.code, visualQuestion.inspectionAttribute)].observation">
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </mat-expansion-panel>
    </ng-container>
    <app-inspection-document [inspectionType]="'vehicle'" *ngIf="typeOfInspection === 'document'"
      [existingFileName]="data?.inspect?.inspectionDocument" [canUpload]="!data?.inspect?.id"
      [settings]="{ licensePlate: data?.licensePlate, cargoId: data?.cargo?.id }"
      (fileSelected)="onFileSelected($event)">
    </app-inspection-document>



    <mat-expansion-panel [expanded]="true" class="dialog-inspection-section my-3">
      <mat-expansion-panel-header>
        <mat-panel-title class="text-strong">
          Mantenimientos del vehículo
        </mat-panel-title>

      </mat-expansion-panel-header>
      <p>
        Ingresa las fechas de los últimos mantenimientos y carga las facturas o comprobantes correspondientes.
      </p>
      <div class="d-flex flex-wrap">
        <mat-form-field class="col-md-6 cursor-pointer" appearance="standard">
          <mat-label>Último mantenimiento preventivo<span class="asterisk">*</span></mat-label>
          <input readonly class="cursor-pointer" type="text" matInput [matDatepicker]="datePickerPreventive"
            [formControl]="form.get('dateMaintenancePreventive')" (click)="datePickerPreventive.open()">
          <mat-datepicker-toggle matSuffix [for]="datePickerPreventive"></mat-datepicker-toggle>
          <mat-datepicker #datePickerPreventive></mat-datepicker>
          <mat-error *ngIf="form.get('dateMaintenancePreventive').errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6 cursor-pointer" appearance="standard">
          <mat-label>Último mantenimiento correctivo<span class="asterisk">*</span></mat-label>
          <input readonly class="cursor-pointer" type="text" matInput [matDatepicker]="datePicker"
            [formControl]="form.get('dateMaintenanceCorrective')" (click)="datePicker.open()">
          <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
          <mat-datepicker #datePicker></mat-datepicker>
          <mat-error *ngIf="form.get('dateMaintenanceCorrective').errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
          </mat-error>
        </mat-form-field>
        <div class="col-md-6">
          <input #inputPreventativeMaintenance class="display-none" type="file"
            (change)="setInstanceFileStorage($event,'preventativeMaintenance')">
          <mat-form-field appearance="standard" (click)="openWindowFile('preventativeMaintenance')">
            <mat-label>Mantenimiento preventivo</mat-label>
            <input matInput type="text" class="field__form--input" readonly
              [formControl]="formPicture.get('preventativeMaintenance')">
            <i class="fas fa-camera i-picture field__form--icon" for="upload-photo"></i>
            <mat-error *ngIf="formPicture.get('preventativeMaintenance').errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="getResourcesPathByTypeFile('preventativeMaintenance')?.url">
            <app-previsualization-resources matSuffix [resource]="getResourcesPathByTypeFile('preventativeMaintenance')"
              [errorLoadResource]="getResourcesPathByTypeFile('preventativeMaintenance') === undefined || getResourcesPathByTypeFile('preventativeMaintenance')?.url === ''"></app-previsualization-resources>
          </ng-container>
        </div>
        <div class="col-md-6">
          <input #inputCorrectiveMaintenance class="display-none" type="file"
            (change)="setInstanceFileStorage($event,'correctiveMaintenance')">
          <mat-form-field appearance="standard" (click)="openWindowFile('correctiveMaintenance')">
            <mat-label>Mantenimiento correctivo</mat-label>
            <input matInput type="text" class="field__form--input" readonly
              [formControl]="formPicture.get('correctiveMaintenance')">
            <i class="fas fa-camera i-picture field__form--icon" for="upload-photo"></i>
            <mat-error *ngIf="formPicture.get('correctiveMaintenance').errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="getResourcesPathByTypeFile('correctiveMaintenance')?.url">
            <app-previsualization-resources matSuffix [resource]="getResourcesPathByTypeFile('correctiveMaintenance')"
              [errorLoadResource]="getResourcesPathByTypeFile('correctiveMaintenance') === undefined || getResourcesPathByTypeFile('correctiveMaintenance')?.url === ''"></app-previsualization-resources>
          </ng-container>
        </div>
        <mat-form-field class="col-md-12" appearance="outline" *ngIf="!this.isVehicleInspectionv3">
          <mat-label>Observación<span class="asterisk">*</span></mat-label>
          <textarea matInput [formControl]="form.get('observation')"></textarea>
          <mat-error *ngIf="form.get('observation').errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
          </mat-error>
          <mat-error *ngIf="form.get('observation').errors?.minlength">
            {{ utils.giveMessageError('MIN_LENGTH_NOT_REACHED', 'observación', minObservation) }}
          </mat-error>
        </mat-form-field>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true" class="dialog-inspection-section my-3">
      <mat-expansion-panel-header>
        <mat-panel-title class="text-strong">
          Fotografías del vehículo
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p>
        Carga fotografías actualizadas del vehículo.
      </p>
      <form class="d-flex flex-wrap" [formGroup]="formPicture">
        <!-- Left lateral Picture-->
        <div class="col-md-4">
          <input #inputLeftLateralPicture class="display-none" type="file"
            (change)="setInstanceFileStorage($event,'leftLateralPicture')">
          <mat-form-field appearance="standard" (click)="openWindowFile('leftLateralPicture')">
            <mat-label>Foto lateral Izquierda del Vehículo<span class="asterisk">*</span></mat-label>
            <input matInput type="text" class="field__form--input" readonly formControlName="leftLateralPicture">
            <i class="fas fa-camera i-picture field__form--icon" for="upload-photo"></i>
            <mat-error *ngIf="formPicture.get('leftLateralPicture').errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="getResourcesPathByTypeFile('leftLateralPicture')?.url">
            <app-previsualization-resources matSuffix [resource]="getResourcesPathByTypeFile('leftLateralPicture')"
              [errorLoadResource]="getResourcesPathByTypeFile('leftLateralPicture') === undefined || getResourcesPathByTypeFile('leftLateralPicture')?.url === ''"></app-previsualization-resources>
          </ng-container>
        </div>
        <!--Right lateral Picture-->
        <div class="col-md-4">
          <input #inputRightLateralPicture class="display-none" type="file"
            (change)="setInstanceFileStorage($event,'rightLateralPicture')">
          <mat-form-field appearance="standard" (click)="openWindowFile('rightLateralPicture')">
            <mat-label>Foto lateral Derecha del Vehículo<span class="asterisk">*</span></mat-label>
            <input matInput type="text" class="field__form--input" readonly formControlName="rightLateralPicture">
            <i class="fas fa-camera i-picture field__form--icon" for="upload-photo"></i>
            <mat-error *ngIf="formPicture.get('rightLateralPicture').errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="getResourcesPathByTypeFile('rightLateralPicture')?.url">
            <app-previsualization-resources matSuffix [resource]="getResourcesPathByTypeFile('rightLateralPicture')"
              [errorLoadResource]="getResourcesPathByTypeFile('rightLateralPicture') === undefined || getResourcesPathByTypeFile('rightLateralPicture')?.url === ''"></app-previsualization-resources>
          </ng-container>
        </div>
        <!--Frontal Picture-->
        <div class="col-md-4">
          <input #inputFrontalImage class="display-none" type="file"
            (change)="setInstanceFileStorage($event,'frontPicture')">
          <mat-form-field appearance="standard" (click)="openWindowFile('frontPicture')">
            <mat-label>Foto frontal del Vehículo<span class="asterisk">*</span></mat-label>
            <input matInput type="text" class="field__form--input" readonly formControlName="frontPicture">
            <i class="fas fa-camera i-picture field__form--icon" for="upload-photo"></i>
            <mat-error *ngIf="formPicture.get('frontPicture').errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="getResourcesPathByTypeFile('frontPicture')?.url">
            <app-previsualization-resources matSuffix [resource]="getResourcesPathByTypeFile('frontPicture')"
              [errorLoadResource]="getResourcesPathByTypeFile('frontPicture') === undefined || getResourcesPathByTypeFile('frontPicture')?.url === ''"></app-previsualization-resources>
          </ng-container>
        </div>
      </form>
    </mat-expansion-panel>

    <div class="d-flex flex-wrap mt-5 mb-3" *ngIf="this.isVehicleInspectionv3">
      <h5 class="text-center col-12 text-bold">Garantía de responsabilidad</h5>
      <label class="mr-3 text-center col-12">
        Yo, <b>{{userName}}</b>, garantizo que el vehículo con placa <b>{{vehiclePlate}} ha recibido mantenimiento
          preventivo y correctivo y se encuentra en óptimas condiciones</b> de funcionamiento para prestar
        el servicio de transporte terrestre de carga por carretera.
      </label>
      <mat-checkbox class="my-3 col-12" [formControl]="form.get('driverWarranty')">
        <span class="text-bold text-break">
          Confirmo que la información proporcionada es correcta y asumo total responsabilidad.
        </span>
      </mat-checkbox>
    </div>

    <mat-card-content class="d-flex flex-column my-3 px-3"
      *ngIf="!isVehicleInspectionv3 && inspection !== 'motorcycle'">
      <div class="content-form d-flex flex-wrap justify-content-between align-items-center">
        <label class="label-field font">¿Se encuentra la unidad en estado optimo?</label>
        <mat-button-toggle-group [(ngModel)]="optimal">
          <mat-button-toggle [value]="true" [disabled]="data.disabled">
            Si
          </mat-button-toggle>
          <mat-button-toggle [value]="false" [disabled]="data.disabled">
            No
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="content-form d-flex flex-wrap justify-content-between align-items-center">
        <label class="label-field font">¿Hay olores presentes dentro de la unidad?</label>
        <mat-button-toggle-group [(ngModel)]="odors">
          <mat-button-toggle [value]="true" [disabled]="data.disabled">
            Si
          </mat-button-toggle>
          <mat-button-toggle [value]="false" [disabled]="data.disabled">
            No
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="content-form d-flex flex-wrap justify-content-between align-items-center">
        <label class="label-field font">¿Hay riesgo de contaminación cruzada?</label>
        <mat-button-toggle-group [(ngModel)]="crossedContamination">
          <mat-button-toggle [value]="true" [disabled]="data.disabled">
            Si
          </mat-button-toggle>
          <mat-button-toggle [value]="false" [disabled]="data.disabled">
            No
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </mat-card-content>

  </div>
  <!-- Btn-->
  <mat-card-actions>
    <button mat-raised-button color="primary" *ngIf="data?.inspect?.id" class="button-width-auto"
      (click)="downloadInspection()">
      Descargar
    </button>
    <button mat-raised-button color="primary" *ngIf="!data?.inspect?.id" class="button-width-auto"
      (click)="saveInspection()">
      Guardar
    </button>
    <button mat-raised-button color="primary" *ngIf="canRejectInspection" class="primary-secondary button-width-auto"
      (click)="confirmRejection()">
      Rechazar
    </button>
    <button mat-raised-button color="primary" *ngIf="canApproveInspection" class="button-width-auto"
      (click)="approve(true)">
      Aprobar
    </button>
  </mat-card-actions>
</div>